// import Phaser from 'phaser'
import Config from '../launch/config'
import Matter from 'matter-js'

export default function move() {
    if (!this.moveMarker || !this.moveMarker.body) {
        return
    }

    const body = this.sprite.body

    this.vector = Matter.Vector.create(body.position.x, body.position.y)
    this.moveVector = Matter.Vector.create(this.moveMarker.x, this.moveMarker.y)

    this.angle = Matter.Vector.angle(this.vector, this.moveVector)
    // const angleReverse = Phaser.Math.Angle.Reverse(angle)

    Matter.Body.setAngle(body, this.angle)
    Matter.Body.setVelocity(body, {
        x: Math.cos(this.angle) * this.speed,
        y: Math.sin(this.angle) * this.speed,
    })
    // Set thrust angle
    // this.thrustEmitter.setAngle(Phaser.Math.RadToDeg(angleReverse))

    // if (this.moveLine) {
    //     this.moveLine.setTo(
    //         body.position.x,
    //         body.position.y,
    //         this.moveMarker.body.position.x,
    //         this.moveMarker.body.position.y
    //     )
    //
    //     this.moveLineGraphics.clear()
    //     this.moveLineGraphics.strokeLineShape(this.moveLine)
    // }

    let shipHitMoveMarker = false

    Config.scene.matter.overlap(
        this.sprite.body,
        this.moveMarker.body,
        (bodyA, bodyB) => {
            shipHitMoveMarker = true
        },
        (ship, moveMarker) => {
            const shipX = ship.position.x
            const shipY = ship.position.y
            const moveMarkerX = moveMarker.position.x
            const moveMarkerY = moveMarker.position.y
            const {numShips} = moveMarker[Config.namespace]

            let buffer = 2
            if (numShips > 1) {
                buffer = buffer * (numShips + 2)
            }

            const isWithinXBufffer =
                shipX > moveMarkerX - buffer && shipX < moveMarkerX + buffer
            const isWithinYBufffer =
                shipY > moveMarkerY - buffer && shipY < moveMarkerY + buffer

            return isWithinXBufffer && isWithinYBufffer
        }
    )

    if (shipHitMoveMarker) {
        Matter.Body.setVelocity(body, {
            x: 0,
            y: 0,
        })
        // this.moveLineGraphics && this.moveLineGraphics.destroy()
        Config.scene.matter.world.remove(this.moveMarker.body)
        this.moveMarker.destroy()
        this.moving = false
        // this.thrustEmitter.stop()
    }
}
